module.exports = __webpack_public_path__ + "static/media/chat14.8ec2dce7.gif";